import React from "react";
import { AudienceDistributionChart } from "./Chart";
import { SinglePageView } from "../core/ListView";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { useGamePlayTests } from "@seabrookstudios/pitch2table";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const AudienceDistribution = ({ gameId }) => {
  const { data: playTests = [] } = useGamePlayTests(gameId);

  const playTestsWithAudience = playTests.filter((pt) => pt.ignore && pt.audience);
  const incompletePlayTests = playTests.filter((pt) => !pt.audience && pt.ignore);

  return (
    <SinglePageView title={`Audience Distribution`}>
      {playTestsWithAudience.length === 0 ? (
        <Box p={1}>
          <Alert severity="warning">
            To use this chart you need to record audience for your play tests. Update your play tests to include
            audience information.
          </Alert>
        </Box>
      ) : (
        <Box p={1}>
          <Alert severity="info">
            This chart shows the distribution of play tests by audience type. Only play tests with recorded audience are
            included.
            {incompletePlayTests.length > 0 && (
              <>
                {" "}
                There are {incompletePlayTests.length} play test{incompletePlayTests.length === 1 ? "" : "s"} without
                audience data.
              </>
            )}
          </Alert>
        </Box>
      )}
      <AudienceDistributionChart gameId={gameId} />
    </SinglePageView>
  );
};
